import React, { createElement, FC, JSX } from 'react';
import { DevicePriceCollectionSchema } from './DevicePriceWrapper.types';
import './DevicePriceWrapper.css';
import DevicePrice from '../DevicePrice/DevicePrice';
import { countZero } from '../../../utils/utils';

const DevicePriceWrapper: FC<any> = ({
  getDeviceID,
  priceContent,
  cardIndex,
  totalLength,
  proceedButtonIcon,
  sbDeviceConstantKeys
}): any => {
  const basePrice = priceContent?.basePrice;
  const installments = priceContent?.installments;
  const smartUpgradeInstallments = priceContent?.smartUpgradeInstallments;

  const totalPriceText = sbDeviceConstantKeys?.dp_total_price;
  let durationDetails: JSX.Element;
  let priceCollection: DevicePriceCollectionSchema = {
    discountedPrice: 0,
    actualPrice: 0,
    durationDetails: null,
    totalDiscount: basePrice?.upFrontPayment?.value,
    totalActual: 0,
    discount: false,
    totalPriceText: totalPriceText,
    priceTerm: '',
  };

  if (smartUpgradeInstallments) {
    let totalBaseDiscount =
      basePrice?.upFrontPayment?.value -
      smartUpgradeInstallments?.discount?.value;
    let monthlyDiscountedPrice =
      smartUpgradeInstallments?.monthlyInstallment?.value;
    let discountPercentage = 0;

    if (priceContent?.dPSubsidyPromotion?.discountedRatePlan) {
      totalBaseDiscount =
        basePrice?.upFrontPayment?.value -
        (Number(priceContent?.dPSubsidyPromotion?.discount?.value) +
          Number(smartUpgradeInstallments?.discount?.value));
      monthlyDiscountedPrice =
        priceContent?.dPSubsidyPromotion?.discountedRatePlan?.detail?.[0]
          ?.installmentAmount;
      discountPercentage = Math.floor(
        ((Number(priceContent?.dPSubsidyPromotion?.discount?.value) +
          Number(smartUpgradeInstallments?.discount?.value)) /
          basePrice?.upFrontPayment?.value) *
          100
      );
    } else {
      discountPercentage = Math.floor(
        (smartUpgradeInstallments?.discount?.value /
          basePrice?.upFrontPayment?.value) *
          100
      );
    }

    durationDetails = createElement(() => {
      return (
        <>
          <div>
            {sbDeviceConstantKeys?.dp_smartupgrade_installment?.replace(
              '{0}',
              smartUpgradeInstallments?.duration
            )}
          </div>
          {priceContent?.dPSubsidyPromotion?.discountedRatePlan ? (
            <div>
              {sbDeviceConstantKeys?.dp_discount_off?.replace(
                '{0}',
                discountPercentage
              )}
            </div>
          ) : (
            <div>
              {sbDeviceConstantKeys?.dp_smatupgrade_discount?.replace(
                '{0}',
                discountPercentage
              )}
              <span className='custDeviceSmartUpgrade'>
                {` `}{sbDeviceConstantKeys?.dp_smartupgrade}
              </span>
            </div>
          )}
        </>
      );
    }, {});

    priceCollection = {
      discountedPrice: monthlyDiscountedPrice,
      actualPrice: installments?.monthlyInstallment?.value,
      durationDetails: durationDetails,
      totalDiscount: totalBaseDiscount,
      totalActual: basePrice?.upFrontPayment?.value,
      discount: true,
      totalPriceText: totalPriceText,
      priceTerm: sbDeviceConstantKeys?.dd_per_month,
    };
  } else if (installments) {
    durationDetails = createElement(() => {
      return (
        <>
          <div>
            {sbDeviceConstantKeys?.dp_monthly_installment?.replace(
              '{0}',
              installments?.duration
            )}
          </div>
          <div>
            {sbDeviceConstantKeys?.dp_down_payment}{' '}
            <span className='fw-bold'>
              {countZero(installments?.upFrontPayment?.value)}
            </span>
          </div>
        </>
      );
    }, {});

    priceCollection = {
      discountedPrice: 0,
      actualPrice: installments?.monthlyInstallment?.value,
      durationDetails: durationDetails,
      totalDiscount: 0,
      totalActual: basePrice?.upFrontPayment?.value,
      discount: false,
      totalPriceText: totalPriceText,
      priceTerm: sbDeviceConstantKeys?.dd_per_month,
    };
    if (priceContent?.dPSubsidyPromotion?.discountedRatePlan) {
      priceCollection = {
        discountedPrice:
          priceContent?.dPSubsidyPromotion?.discountedRatePlan?.detail?.[0]
            ?.installmentAmount,
        actualPrice: installments?.monthlyInstallment?.value,
        durationDetails: durationDetails,
        totalDiscount:
          basePrice?.upFrontPayment?.value -
          priceContent?.dPSubsidyPromotion?.discount?.value,
        totalActual: basePrice?.upFrontPayment?.value,
        discount: true,
        totalPriceText: totalPriceText,
        priceTerm: sbDeviceConstantKeys?.dd_per_month,
      };
    }
  }
  return (
    <DevicePrice priceCollection={priceCollection} getDeviceID={getDeviceID} proceedButtonIcon={proceedButtonIcon}  cardIndex={cardIndex} totalLength={totalLength} />
  );
};

export default DevicePriceWrapper;
